if (!customElements.get('fp-addon')) {
  // Digitale add-on: hoort alleen bij een fysiek portret. Op de PDP wordt hij
  // NIET los aan de cart toegevoegd maar gaat in hetzelfde /cart/add-verzoek
  // mee met het portret (fpAddonBundle, aangeroepen vanuit product-form.js):
  // mislukt het portret, dan komt de add-on er ook niet in. Verdwijnt het
  // laatste fysieke portret later uit de cart, dan ruimt fpAddonSweep de
  // add-on op (order FP19732: alleen de verborgen add-on bleef over).
  const ADDON_HANDLES = ['digital-artwork-download'];
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Herschrijft de FormData van het hoofdproduct naar items[0][...] en voegt de
  // aangevinkte, zichtbare PDP-add-ons toe als items[1..n]. Eén verzoek, dus
  // atomair: faalt één regel, dan komt er niets in de cart.
  window.fpAddonBundle = function (formData, form) {
    // getAttribute i.p.v. form.id: de <input name="id"> (variant-id) overschaduwt
    // de id-property van het formulier.
    const formId = form && form.getAttribute('id');
    if (!formId || formData.has('items[0][id]')) return;
    const addons = Array.from(document.querySelectorAll('fp-addon.fp-pdp-addon')).filter(
      (el) => el.dataset.productFormId === formId && el.isActive()
    );
    if (!addons.length) return;
    const main = [];
    Array.from(formData.entries()).forEach(([key, value]) => {
      let target = null;
      if (key === 'id' || key === 'quantity' || key === 'selling_plan') target = `items[0][${key}]`;
      else if (/^properties\[.+\]$/.test(key)) target = `items[0][properties][${key.slice(11, -1)}]`;
      if (target) main.push([key, target, value]);
    });
    if (!main.some(([key]) => key === 'id')) return;
    main.forEach(([key]) => formData.delete(key));
    main.forEach(([, target, value]) => formData.append(target, value));
    addons.forEach((el, i) => {
      const n = i + 1;
      formData.append(`items[${n}][id]`, el.dataset.variantId);
      formData.append(`items[${n}][quantity]`, '1');
      const props = el.addProperties();
      Object.keys(props).forEach((k) => formData.append(`items[${n}][properties][${k}]`, props[k]));
    });
  };

  // Ruimt digitale add-ons op die niet (meer) bij een fysiek portret horen:
  // zonder fysieke regel verdwijnen ze, en een dubbele hoeveelheid gaat terug
  // naar 1. `cart` is een volledige cart (change.js/update.js/cart.js).
  window.fpAddonSweep = async function (cart) {
    try {
      if (!cart || !Array.isArray(cart.items)) return;
      const addons = cart.items.filter((i) => ADDON_HANDLES.includes(i.handle));
      if (!addons.length) return;
      const hasMain = cart.items.some((i) => !ADDON_HANDLES.includes(i.handle) && i.requires_shipping);
      const updates = {};
      addons.forEach((i) => {
        if (!hasMain) updates[i.key] = 0;
        else if (i.quantity > 1) updates[i.key] = 1;
      });
      if (!Object.keys(updates).length) return;
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) return;
      const next = await response.json();
      await refreshCartViews(next);
    } catch (e) { /* cart blijft zoals hij was; volgende cart-actie probeert opnieuw */ }
  };

  async function refreshCartViews(cart) {
    if (window.SLIDECART_UPDATE) window.SLIDECART_UPDATE();
    const empty = cart.item_count === 0;
    const drawer = document.querySelector('cart-drawer');
    const page = document.querySelector('cart-items');
    if (empty && page && !drawer) { window.location.reload(); return; }
    if (empty && drawer) {
      // Dawn zet het lege scherm alleen server-side neer; items/header/footer
      // vervangen is dan niet genoeg.
      try {
        const html = await (await fetch(`${window.routes.cart_url}?section_id=cart-drawer`)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.querySelector('.drawer__inner');
        const dst = drawer.querySelector('.drawer__inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
      } catch (e) { /* leeg-klasse hieronder volstaat */ }
    }
    drawer?.classList.toggle('is-empty', empty);
    page?.classList.toggle('is-empty', empty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
    if (!empty) {
      await Promise.all(
        Array.from(document.querySelectorAll('cart-items, cart-drawer-items')).map((el) => el.onCartUpdate?.())
      );
    }
  }

  // Cart-wijzigingen in drawer/pagina (verwijderen, aantal) leveren de volledige
  // cart; productformulier-adds leveren alleen de toegevoegde regels.
  const sweepFromEvent = (event) => {
    if (event && event.source === 'cart-items' && event.cartData) window.fpAddonSweep(event.cartData);
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, sweepFromEvent);
  }
  // Verouderde cart (andere tab, oude sessie): één controle bij laden op de
  // plekken waar de klant de add-on kan zien.
  const initialSweep = () => {
    if (!document.querySelector('fp-addon.fp-pdp-addon, cart-items')) return;
    fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => cart && window.fpAddonSweep(cart))
      .catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialSweep);
  else initialSweep();

  class FPAddon extends HTMLElement {
    connectedCallback() {
      // De AI-modal schuift dit blok bij openen en sluiten heen en weer, en elke
      // verplaatsing roept connectedCallback opnieuw aan. Eén keer binden: met
      // gestapelde listeners ging één vinkje 2, 4, 6... keer de cart in.
      if (this.checkbox) return;
      this.checkbox = this.querySelector('.fp-pdp-addon__cb');
      this.checkbox?.addEventListener('change', (event) => {
        // In de cart-drawer staat deze checkbox binnen <cart-drawer-items>,
        // dat op elk change-event de quantity-validatie draait. Hier stoppen.
        event.stopPropagation();
        // PDP: het vinkje is alleen een keuze; de add-on gaat mee met Add to
        // cart (fpAddonBundle). In de cart-drawer staat het portret al in de
        // cart en werkt het vinkje direct.
        if (!this.isPdp) this.toggle();
      });
      this.watchVariant();
      if (this.isPdp && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        // Portret + add-on zijn in de cart: vinkje terug, anders gaat de
        // add-on bij de volgende Add to cart nog een keer mee.
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.source === 'product-form' && this.checkbox) this.checkbox.checked = false;
        });
      }
    }

    get isPdp() {
      return this.classList.contains('fp-pdp-addon');
    }

    // Zichtbaar, aangevinkt en niet uitgeschakeld: mag meegestuurd worden.
    isActive() {
      return !!this.checkbox && this.checkbox.checked && !this.checkbox.disabled && !this.hidden;
    }

    addProperties() {
      const props = {};
      if (this.dataset.digital) {
        props._withdrawal_waiver = 'yes';
        if (this.dataset.propertyLabel && this.dataset.propertyValue) {
          props[this.dataset.propertyLabel] = this.dataset.propertyValue;
        }
      }
      return props;
    }

    // Bij een digitale variant is deze add-on dubbelop. De lijst met variant-ids
    // komt uit de liquid (alles zonder requires_shipping), zodat het niet op een
    // vertaalde optienaam hoeft te matchen.
    watchVariant() {
      const raw = this.dataset.hideForVariants || '';
      this.hideFor = raw.split(',').map((id) => id.trim()).filter(Boolean);
      if (!this.hideFor.length) return;
      // De hidden input met de variant-id is de bron; Dawn werkt die bij na het
      // wisselen van maat, ook als het blok in de AI-modal is ingeschoven.
      this.variantInput =
        document.getElementById(this.dataset.productFormId)?.querySelector('[name="id"]') ||
        document.querySelector('product-form form [name="id"]');
      if (!this.variantInput) return;
      this.applyVariant();
      new MutationObserver(() => this.applyVariant()).observe(this.variantInput, { attributes: true });
      document.addEventListener('change', () => requestAnimationFrame(() => this.applyVariant()));
    }

    applyVariant() {
      const hide = this.hideFor.includes(String(this.variantInput.value));
      if (hide === this.hidden) return;
      this.hidden = hide;
      // Digitale variant: geen add-on. Uitvinken en uitschakelen, zodat er
      // niets van meegestuurd wordt; terug naar een canvasmaat: zichtbaar en
      // uitgevinkt. (Het hidden-attribuut zelf wordt in fp-pdp.css afgedwongen.)
      if (this.checkbox) {
        if (hide) this.checkbox.checked = false;
        this.checkbox.disabled = hide;
      }
    }

    async toggle() {
      const variantId = Number(this.dataset.variantId);
      if (!variantId) return;
      this.checkbox.disabled = true;
      try {
        if (this.checkbox.checked) {
          // Digitale add-on (data-digital, bv. digital-artwork-download): het
          // vinkje aanzetten IS hier de uitdrukkelijke instemming uit art.
          // 16(m) — de consent-zin staat als tweede regel in de add-on-tekst
          // (general.fp.digital.consent_addon). Property gaat direct mee de
          // cart in, zodat de orderflow 'm op de line item terugvindt.
          const body = { id: variantId, quantity: 1 };
          const props = this.addProperties();
          if (Object.keys(props).length) body.properties = props;
          await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });
        } else {
          await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(variantId), quantity: 0 }),
          });
        }
        if (window.SLIDECART_UPDATE) window.SLIDECART_UPDATE();
        document.querySelectorAll('cart-items, cart-drawer-items').forEach((el) => el.onCartUpdate?.());
        document.dispatchEvent(new CustomEvent('fp-addon:changed', { detail: { variantId } }));
      } catch (e) {
        this.checkbox.checked = !this.checkbox.checked;
      } finally {
        this.checkbox.disabled = false;
      }
    }
  }
  customElements.define('fp-addon', FPAddon);
}
